import { initChatbot } from '@autofact-lib/autofact-lib-ts-chatbot';

function pushChatbotEvent(contentType, contentId) {
  if (!contentType || !contentId) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'select_content',
    content_type: contentType,
    content_id: contentId,
  });
}

function setupChatbot(chatbotConfig, analytics, extraData) {
  window.chatbot = initChatbot(chatbotConfig);

  if (!window.chatbot) {
    return;
  }

  window.chatbot.on('widgetOpened', function () {
    pushChatbotEvent(analytics.contentType, analytics.contentIdOpen);
  });

  window.chatbot.on('messageSent', function (data) {
    if (data && data.message !== '') {
      pushChatbotEvent(analytics.contentType, analytics.contentIdSent);
    }
  });

  if (extraData) {
    window.chatbot.setExtraData(extraData);
  }
}

async function resolveShowChatbot(growthbookConfig) {
  var growthbook = window.AutofactGrowthbook;
  var fallback = !!(growthbookConfig && growthbookConfig.fallback);

  if (!growthbookConfig || !growthbookConfig.featureKey) {
    return fallback;
  }

  if (growthbook && growthbook.getFeatureValue) {
    return growthbook.getFeatureValue(growthbookConfig);
  }

  return fallback;
}

(async function () {
  var config = window.Autofact && window.Autofact.chatbotConfig;

  if (!config) {
    return;
  }

  var growthbookConfig = config.growthbook;
  var analytics = {
    contentType: config.analyticsContentType,
    contentIdOpen: config.analyticsContentIdOpen,
    contentIdSent: config.analyticsContentIdSent,
  };
  var extraData = config.extraData;
  var chatbotConfig = Object.assign({}, config);

  delete chatbotConfig.growthbook;
  delete chatbotConfig.extraData;
  delete chatbotConfig.analyticsContentType;
  delete chatbotConfig.analyticsContentIdOpen;
  delete chatbotConfig.analyticsContentIdSent;

  if (growthbookConfig) {
    var showChatbot = await resolveShowChatbot(growthbookConfig);

    if (!showChatbot) {
      return;
    }
  }

  setupChatbot(chatbotConfig, analytics, extraData);
})();
